module.exports = __webpack_public_path__ + "static/media/shoes_share.efb1005a.jpg";